import LastPageIcon from "@mui/icons-material/LastPage";
import classes from "./TableFooter.module.css";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { renderToString } from "react-dom/server";

const TableFooter = ({
  changeDataLimitHandler,
  totalRecords,
  currentPage,
  dataLimit,
  goToNextPage,
  changePage,
  goToPreviousPage,
  pages,
  forceLtr,
}) => {
  const moveToFirstPage = (e) => {
    if (currentPage !== 1 && totalRecords !== 0) {
      let basedOnWhatWeHad = { target: { textContent: 1 } };
      changePage(basedOnWhatWeHad);
    }
  };
  const moveToPrevPage = (e) => {
    if (currentPage !== 1 && totalRecords !== 0) {
      goToPreviousPage();
    }
  };
  const moveToNextPage = (e) => {
    if (currentPage !== pages && totalRecords !== 0) {
      goToNextPage();
    }
  };
  const moveToLastPage = (e) => {
    if (currentPage !== pages && totalRecords !== 0) {
      let basedOnWhatWeHad = { target: { textContent: pages } };
      changePage(basedOnWhatWeHad);
    }
  };

  return (
    <div className={classes.footer}>
      <div className={classes.newContainer}>
        <div className={classes.newRowChange}>
          {forceLtr ? "Records per page" : "تعداد در صفحه"}
          <select
            value={dataLimit}
            onChange={changeDataLimitHandler}
            className={classes.newDataLimitSelectInput}
          >
            <option value="10">10</option> <option value="25">25</option> <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>

        <div className={[classes.newTotalNum, forceLtr ? classes.ltrDir : null].join(" ")}>
          {totalRecords === 0
            ? forceLtr
              ? "Records 0"
              : "0"
            : // : "رکوردی موجود نیست"
              `${`${
                currentPage === pages ? totalRecords : `${(currentPage - 1) * dataLimit + dataLimit}`
              }  -  ${(currentPage - 1) * dataLimit + 1}`}    ${
                forceLtr ? "From" : "از"
              }    ${totalRecords}`}
        </div>
        <div className={classes.newPagination}>
          <span
            className={[
              classes.paginationBtn,
              forceLtr ? classes.rotateIcon : null,
              currentPage == "1" || totalRecords === 0
                ? classes.newDisabledPagi
                : classes.newEnabledPagi,
            ].join(" ")}
            onClick={moveToFirstPage}
          >
            <LastPageIcon />
          </span>
          <span
            className={[
              classes.paginationBtn,
              forceLtr ? classes.rotateIcon : null,
              currentPage == "1" || totalRecords === 0
                ? classes.newDisabledPagi
                : classes.newEnabledPagi,
            ].join(" ")}
            onClick={moveToPrevPage}
          >
            <KeyboardArrowRightIcon />
          </span>
          <span
            className={[
              classes.paginationBtn,
              forceLtr ? classes.rotateIcon : null,
              currentPage == pages || totalRecords === 0
                ? classes.newDisabledPagi
                : classes.newEnabledPagi,
            ].join(" ")}
            onClick={moveToNextPage}
          >
            <KeyboardArrowLeftIcon />
          </span>
          <span
            className={[
              classes.paginationBtn,
              forceLtr ? classes.rotateIcon : null,
              currentPage == pages || totalRecords === 0
                ? classes.newDisabledPagi
                : classes.newEnabledPagi,
            ].join(" ")}
            onClick={moveToLastPage}
          >
            <FirstPageIcon />
          </span>
        </div>
      </div>
    </div>
  );
};

export default TableFooter;
